import { useParams } from 'react-router'

export function useCategorySlug () {
  const params = useParams()
  const categorySubChildrenSlug = params.categorySubChildrenSlug
  const categoryChildrenSlug = params.categoryChildrenSlug
  const categorySlug = params.categorySlug

  return categorySubChildrenSlug ?? categoryChildrenSlug ?? categorySlug
}